import CircleTick from '@service-victoria/component-library/components/Icons/CircleTick';
import Spinner from '@service-victoria/component-library/components/Icons/Spinner';
import Text from '@service-victoria/component-library/components/Text';
import colors from '@service-victoria/component-library/utils/colors';
import device from '@service-victoria/component-library/utils/device';
import styled from 'styled-components';

export const BaseWrapper = styled.div``;

export const StyledSpinner = styled(Spinner)`
  position: absolute;
  width: 30px;
  height: 30px;
  left: 310px; // 350px max container width on input - 30px wide - 10px padding
  top: 38px; // 28px label height + 10px padding

  @media ${device.isMobile} {
    left: auto;
    right: 10px;
  }
`;

export const Wrapper = styled(BaseWrapper)`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const HeadingWrapper = styled(BaseWrapper)`
  margin-bottom: 17px;
`;

export const DetailsWrapper = styled(Wrapper)``;

export const ManualAddressLinkWrapper = styled(BaseWrapper)`
  margin-top: 8px;
`;

export const BackToManualAddressLinkWrapper = styled(BaseWrapper)`
  margin-bottom: 24px;
`;

export const ToggleAddressMode = styled.a`
  text-decoration: underline;
  font-size: 16px;
  font-weight: 500;
  color: ${colors.orange};
`;

export const GoBackToAutoWrapper = styled.a``;

export const InputContainer = styled(BaseWrapper)`
  margin: 8px 0;
`;

export const TipBox = styled(BaseWrapper)`
  /* Auto Layout */
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  max-width: 350px;

  /* Confirmation / Green 10 */
  background: rgba(39, 135, 29, 0.1);
  border-radius: 4px;
`;

export const TickWrapper = styled(CircleTick)`
  position: relative;
  width: 24px;
  height: 24px;
  margin-right: 12px;
  top: 4px;
`;

export const Heading = styled(Text.Heading.H2).attrs({ fontWeight: 600 })`
  margin-bottom: 24px;
`;
